export const SUPPORTED_LOCALES = ['en', 'es', 'fr', 'de', 'pt'] as const;

export type Locale = (typeof SUPPORTED_LOCALES)[number];

export const DEFAULT_LOCALE: Locale = 'en';

export const LOCALE_DISPLAY_NAMES: Record<Locale, string> = {
  en: 'English',
  es: 'Español',
  fr: 'Français',
  de: 'Deutsch',
  pt: 'Português',
};

export const COUNTRY_LOCALE_MAP: Record<string, Locale> = {
  US: 'en',
  GB: 'en',
  CA: 'en',
  AU: 'en',
  NZ: 'en',
  IE: 'en',
  MX: 'es',
  ES: 'es',
  AR: 'es',
  CO: 'es',
  CL: 'es',
  PE: 'es',
  VE: 'es',
  EC: 'es',
  GT: 'es',
  CU: 'es',
  DO: 'es',
  HN: 'es',
  SV: 'es',
  NI: 'es',
  CR: 'es',
  PA: 'es',
  UY: 'es',
  PY: 'es',
  BO: 'es',
  PR: 'es',
  FR: 'fr',
  BE: 'fr',
  CH: 'fr',
  LU: 'fr',
  MC: 'fr',
  SN: 'fr',
  CI: 'fr',
  ML: 'fr',
  BF: 'fr',
  NE: 'fr',
  TD: 'fr',
  GN: 'fr',
  RW: 'fr',
  HT: 'fr',
  CD: 'fr',
  CG: 'fr',
  GA: 'fr',
  CM: 'fr',
  MG: 'fr',
  DE: 'de',
  AT: 'de',
  LI: 'de',
  BR: 'pt',
  PT: 'pt',
  AO: 'pt',
  MZ: 'pt',
};

export const OG_LOCALE_MAP: Record<Locale, string> = {
  en: 'en_US',
  es: 'es_ES',
  fr: 'fr_FR',
  de: 'de_DE',
  pt: 'pt_BR',
};

export const isLocale = (value: string): value is Locale => {
  return (SUPPORTED_LOCALES as readonly string[]).includes(value);
};
